function serializeArray(form) {
  const arr = [];

  Array.prototype.slice.call(form.elements).forEach((field) => {
    if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;

    if (field.type === 'select-multiple') {
      Array.prototype.slice.call(field.options).forEach((option) => {
        if (!option.selected) return;

        arr.push({
          name: field.name,
          value: option.value,
        });
      });

      return;
    }

    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;

    arr.push({
      name: field.name,
      value: field.value,
    });
  });

  return arr;
}

async function addItem(data) {
  const params = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const result = await fetch('/cart/add.js', params)
    .then((res) => res.json())
    .catch((error) => console.log(error));

  return result;
}

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.productForm = (function (exports,themeProduct) {
  'use strict';

  function Listeners() {
    this.entries = [];
  }

  Listeners.prototype.add = function(element, event, fn) {
    this.entries.push({ element: element, event: event, fn: fn });
    element.addEventListener(event, fn);
  };

  Listeners.prototype.removeAll = function() {
    this.entries = this.entries.filter(function(listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  var selectors = {
    idInput: '[name="id"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]'
  };

  // Public Methods
  // -----------------------------------------------------------------------------

  /**
   * Returns a URL with a variant ID query parameter. Useful for updating window.history
   * with a new URL based on the currently select product variant.
   * @param {string} url - The URL you wish to append the variant ID to
   * @param {number} id  - The variant ID you wish to append to the URL
   * @returns {string} - The new url which includes the variant ID query parameter
   */

  function getUrlWithVariant(url, id) {
    if (/variant=/.test(url)) {
      return url.replace(/(variant=)[^&]+/, '$1' + id);
    } else if (/\?/.test(url)) {
      return url.concat('&variant=').concat(id);
    }

    return url.concat('?variant=').concat(id);
  }

  /**
   * Constructor class that creates a new instance of a product form controller.
   *
   * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
   * @param {Object} product - A product object
   * @param {Object} options - Optional options object
   * @param {Function} options.onOptionChange - Callback for whenever an option input changes
   * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
   * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
   * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
   */
  function ProductForm(element, product, options) {
    this.element = element;
    this.product = _validateProductObject(product);

    options = options || {};

    this._listeners = new Listeners();
    this._listeners.add(
      this.element,
      'submit',
      this._onSubmit.bind(this, options)
    );

    this.optionInputs = this._initInputs(
      selectors.optionInput,
      options.onOptionChange
    );

    this.quantityInputs = this._initInputs(
      selectors.quantityInput,
      options.onQuantityChange
    );

    this.propertyInputs = this._initInputs(
      selectors.propertyInput,
      options.onPropertyChange
    );
  }

  /**
   * Cleans up all event handlers that were assigned when the Product Form was constructed.
   * Useful for use when a section needs to be reloaded in the theme editor.
   */
  ProductForm.prototype.destroy = function() {
    this._listeners.removeAll();
  };

  /**
   * Getter method which returns the array of currently selected option values
   *
   * @returns {Array} An array of option values
   */
  ProductForm.prototype.options = function() {
    return _serializeOptionValues(this.optionInputs, function(item) {
      var regex = /(?:^(options\[))(.*?)(?:\])/;
      item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
      return item;
    });
  };

  /**
   * Getter method which returns the currently selected variant, or `null` if variant
   * doesn't exist.
   *
   * @returns {Object|null} Variant object
   */
  ProductForm.prototype.variant = function() {
    return themeProduct.getVariantFromSerializedArray(this.product, this.options());
  };

  /**
   * Getter method which returns a collection of objects containing name and values
   * of property inputs
   *
   * @returns {Array} Collection of objects with name and value keys
   */
  ProductForm.prototype.properties = function() {
    var properties = _serializePropertyValues(this.propertyInputs, function(
      propertyName
    ) {
      var regex = /(?:^(properties\[))(.*?)(?:\])/;
      var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
      return name;
    });

    return Object.entries(properties).length === 0 ? null : properties;
  };

  /**
   * Getter method which returns the current quantity or 1 if no quantity input is
   * included in the form
   *
   * @returns {Array} Collection of objects with name and value keys
   */
  ProductForm.prototype.quantity = function() {
    return this.quantityInputs[0]
      ? Number.parseInt(this.quantityInputs[0].value, 10)
      : 1;
  };

  // Private Methods
  // -----------------------------------------------------------------------------
  ProductForm.prototype._setIdInputValue = function(value) {
    var idInputElement = this.element.querySelector(selectors.idInput);

    if (!idInputElement) {
      idInputElement = document.createElement('input');
      idInputElement.type = 'hidden';
      idInputElement.name = 'id';
      this.element.appendChild(idInputElement);
    }

    idInputElement.value = value.toString();
  };

  ProductForm.prototype._onSubmit = function(options, event) {
    event.dataset = this._getProductFormEventData();

    if (event.dataset.variant) {
      this._setIdInputValue(event.dataset.variant.id);
    }

    if (options.onFormSubmit) {
      options.onFormSubmit(event);
    }
  };

  ProductForm.prototype._onFormEvent = function(cb) {
    if (typeof cb === 'undefined') {
      return Function.prototype;
    }

    return function(event) {
      event.dataset = this._getProductFormEventData();
      cb(event);
    }.bind(this);
  };

  ProductForm.prototype._initInputs = function(selector, cb) {
    var elements = Array.prototype.slice.call(
      this.element.querySelectorAll(selector)
    );

    return elements.map(
      function(element) {
        this._listeners.add(element, 'change', this._onFormEvent(cb));
        return element;
      }.bind(this)
    );
  };

  ProductForm.prototype._getProductFormEventData = function() {
    return {
      options: this.options(),
      variant: this.variant(),
      properties: this.properties(),
      quantity: this.quantity()
    };
  };

  function _serializeOptionValues(inputs, transform) {
    return inputs.reduce(function(options, input) {
      if (
        input.checked || // If input is a checked (means type radio or checkbox)
        (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
      ) {
        options.push(transform({ name: input.name, value: input.value }));
      }

      return options;
    }, []);
  }

  function _serializePropertyValues(inputs, transform) {
    return inputs.reduce(function(properties, input) {
      if (
        input.checked || // If input is a checked (means type radio or checkbox)
        (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
      ) {
        properties[transform(input.name)] = input.value;
      }

      return properties;
    }, {});
  }

  function _validateProductObject(product) {
    if (typeof product !== 'object') {
      throw new TypeError(product + ' is not an object.');
    }

    if (typeof product.variants[0].options === 'undefined') {
      throw new TypeError(
        'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
      );
    }

    return product;
  }

  exports.getUrlWithVariant = getUrlWithVariant;
  exports.ProductForm = ProductForm;

  return exports;

}({},Shopify.theme.product));

class Product {
  constructor(elem) {
    this.wrapper = elem;
    this.sectionId = this.wrapper.getAttribute('data-section-id');
    this.handle = this.wrapper.getAttribute('data-handle');
    this.submitButton = this.wrapper.querySelector('[data-submit-button]');
    this.submitButtonText = this.wrapper.querySelector('[data-submit-button]');
    this.priceContainer = this.wrapper.querySelector('[data-price-wrapper]');
    this.shopifyButtons = this.wrapper.querySelector('[data-shopify="payment-button"]');
    this.availabilityInStock = this.wrapper.querySelector('.js-availability-stock');
    this.availabilityBlock = this.wrapper.querySelector('.js-availability-block');
    this.sizeChart = this.wrapper.querySelector('.size-chart-link');

    this.initPickupAvailability();
    // this.sizeChartInit();
    this.product = this.getProduct();
    this.initVariantSelects();
    this.initQuantitySelector();
    this.initFancybox();
    this.getVariantData(this.variantSelects ?? this.variantRadios);
    this.updateOptions(this.variantSelects ?? this.variantRadios);
    this.stickyAddToCart();
    window.addEventListener('scroll', () => {
      this.stickyAddToCart();
    });
    this.initModelViewer();
    this.initSubmit();
    this.initProductRecommendations();
    this.waitForElement('.shopify-payment-button__button--unbranded').then((node) => {
      const dynamicButtonPlaceholder = window.theme.dynamic_button_placeholder;

      setTimeout(() => {
        node.innerHTML = dynamicButtonPlaceholder;
        node.style.display = 'block';
      }, 0);
    });
    
  }

  updatePickupAvailability(variant) {
    if (!variant) return false;

    const pickupAvailabilityInfoWrapper = this.wrapper.querySelector('[data-store-availability-container]');

    if (!pickupAvailabilityInfoWrapper) return false;

    fetch(`${window.Shopify.routes.root}variants/${variant.id}`)
      .then((response) => response.text())
      .then((text) => {
        const pickupAvailabilityDrawerWrapper = this.wrapper.querySelector('.pickup-availability-drawer');

        const html = new DOMParser().parseFromString(text, 'text/html');
        const pickupAvailabilityInfoHTML = html.querySelector('[data-store-availability-container]');
        const pickupAvailabilityDrawerHTML = html.querySelector('.pickup-availability-drawer');

        pickupAvailabilityInfoWrapper.innerHTML = '';
        pickupAvailabilityInfoHTML &&
          pickupAvailabilityInfoWrapper.insertAdjacentHTML('afterbegin', pickupAvailabilityInfoHTML?.innerHTML);

        pickupAvailabilityDrawerWrapper.innerHTML = '';
        pickupAvailabilityDrawerHTML &&
          pickupAvailabilityDrawerWrapper.insertAdjacentHTML('afterbegin', pickupAvailabilityDrawerHTML?.innerHTML);
        this.initPickupAvailability();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initPickupAvailability() {
    this.buttonPickupAvailability = this.wrapper.querySelector('.pickup-availability-button');

    if (!this.buttonPickupAvailability) return false;

    this._openButton();
    this._closeButton();
  }

  _openButton() {
    this.buttonPickupAvailability.addEventListener('click', () => {
      document.querySelector('html').classList.add('pickup-availability-active');
    });
  }

  _closeButton() {
    this.wrapper.querySelector('.btn-closer').addEventListener('click', () => {
      document.querySelector('html').classList.remove('pickup-availability-active');
    });
  }

  stickyAddToCart() {
    if (!document.querySelector('.custom-qty-box')) {
      return false;
    }
    document.querySelector('.custom-qty-box').classList.remove('is-visible');
    document.querySelector('.custom-qty-box').classList.remove('ProductStickyAddToCart');
    
    const scroll = window.pageYOffset;
    const elemTop = document.querySelector('.custom-qty-box').offsetTop;
    const elemBottom = elemTop + document.querySelector('.custom-qty-box').offsetHeight - document.querySelector('header').offsetHeight;

    const footerLimit = document.querySelector('footer').offsetTop + document.querySelector('.custom-qty-box').offsetHeight - window.outerHeight;
    if (scroll >= elemBottom && scroll <= footerLimit) {
      document.querySelector('.custom-qty-box').classList.add('is-visible');
      document.querySelector('.custom-qty-box').classList.add('ProductStickyAddToCart');
    } else {
      document.querySelector('.custom-qty-box').classList.remove('is-visible');
      document.querySelector('.custom-qty-box').classList.remove('ProductStickyAddToCart');
    }
  }

  initModelViewer() {
    const modelViewerEvent = new CustomEvent('activeModelSlide');

    const galleryWrapper = this.wrapper.querySelector('.product__gallery-slider');

    if (!galleryWrapper) return false;

    const gallerySlides = galleryWrapper.querySelectorAll('.product__gallery-slider__item');

    gallerySlides.forEach((slide) => {
      if (slide.querySelector('product-model') || slide.querySelector('deferred-media')) {
        const viewBtn = slide.querySelector('.deferred-media__poster');

        viewBtn.addEventListener('click', () => {
          window.dispatchEvent(modelViewerEvent);
        });
      }
    });
  }

  initVariantSelects() {
    this.variantSelects = this.wrapper.querySelector('#variant-selects');
    this.variantRadios = this.wrapper.querySelector('#variant-radios');

    if (this.variantSelects) {
      this.productForm = this.wrapper.querySelector(`#product-form-${this.variantSelects.dataset.section}`);
      this.inputName = this.productForm.querySelector('input[name="id"]');
      this.inputName.disabled = false;
      this.variantSelects.addEventListener('change', this.onVariantChange.bind(this, this.variantSelects, 'select'));
      var _this = this;
      function sub_price_update() {
        if (document.querySelector('.appstle_sub_widget')) {
          if (document.querySelector('.appstle_sub_widget') && document.querySelector('.appstle_subscription_wrapper [name="selling_plan"]:checked').value != '') {
            var discount = parseInt(document.querySelector('[data-product-form]').getAttribute('data-discount'))
            var price = parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-price')) * ((100 - discount)/100);
          } else {
            var price = parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-price'));
          }
          
          var html = `<div class="product__price__box flex flex-wrap items-center"> 
            <ins data-product-price="">${formatMoney(price, theme.moneyFormat)}</ins>
            ${parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-compare-price')) > parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-price')) ?  `<span class="accessibility" data-compare-text="">Regular price</span>
            <del data-compare-price="">${formatMoney(parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-compare-price')), theme.moneyFormat)}</del>`: ``}
          </div>`
          _this.submitButton.querySelector('.product__price__box').innerHTML = html;
          _this.subscriptionChange(_this);
        } else {
          setTimeout(function() {
            sub_price_update()
          }, 1000);
        }
      }
      sub_price_update();
    }

    if (this.variantRadios) {
      this.productForm = this.wrapper.querySelector(`#product-form-${this.variantRadios.dataset.section}`);
      this.inputName = this.productForm.querySelector('input[name="id"]');
      this.inputName.disabled = false;
      this.variantRadios.addEventListener('change', this.onVariantChange.bind(this, this.variantRadios, 'input'));
    }

    if (!this.variantRadios && !this.variantSelects) {
      this.inputName = this.wrapper.querySelector('#product-id');
      this.inputName.disabled = false;
    }
  }

  subscriptionChange(_this) {
    if (document.querySelector('.appstle_subscription_wrapper [name="selling_plan"]')) {
        document.addEventListener('change', function(e) {
          if (e.target == document.querySelector('#appstle_selling_plan_label_20[name="selling_plan"]') || e.target == document.querySelector('#appstle_selling_plan_label_10[name="selling_plan"]')) {
            if (document.querySelector('.appstle_sub_widget') && document.querySelector('.appstle_subscription_wrapper [name="selling_plan"]:checked').value != '') {
              var discount = parseInt(document.querySelector('[data-product-form]').getAttribute('data-discount'))
              var price = parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-price')) * ((100 - discount)/100);
            } else {
              var price = parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-price'));
            }
            
            var html = `<div class="product__price__box flex flex-wrap items-center"> 
              <ins data-product-price="">${formatMoney(price, theme.moneyFormat)}</ins>
              ${parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-compare-price')) > parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-price')) ?  `<span class="accessibility" data-compare-text="">Regular price</span>
              <del data-compare-price="">${formatMoney(parseInt(_this.submitButton.querySelector('.product__price').getAttribute('data-compare-price')), theme.moneyFormat)}</del>`: ``}
            </div>`
            _this.submitButton.querySelector('.product__price__box').innerHTML = html;
          };
        });
    }
  }

  initQuantitySelector() {
    const quantityInput = this.wrapper.querySelector('#Quantity');

    quantityInput?.addEventListener('change', (e) => {
      const value = Math.max(1, e.target.value);

      quantityInput.value = value;
    });
    const quantityDecrease = this.wrapper.querySelector('.jcf-btn-dec');
    const quantityIncrease = this.wrapper.querySelector('.jcf-btn-inc');

    quantityDecrease?.addEventListener('click', (e) => {
      if (quantityInput.value > 1) {
        quantityInput.value = +quantityInput.value - 1;
      }
    });

    quantityIncrease?.addEventListener('click', (e) => {
      quantityInput.value = +quantityInput.value + 1;
    });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessage = this.errorMessage || this.wrapper.querySelector('.product-form__error-message');

    this.errorMessage?.classList.toggle('invisible', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  removeErrorMessage() {
    const removeErrMessage = this.wrapper.querySelector('.product-form__error-message');

    if (removeErrMessage) this.handleErrorMessage();
  }

  onVariantChange(el, selector) {
    this.updateOptions(el, selector);
    this.updateMasterId();
    this.onOptionChange(this.currentVariant);
    this.removeErrorMessage();
    this.updateVariantInput(this.currentVariant);
  }

  updateOptions(el, selector) {
    if (!el) return;

    if (selector === 'input') {
      let newAcc = [];

      this.optionsValues = Array.from(el.querySelectorAll(selector)).reduce((acc, curr) => {
        if (curr.checked) {
          newAcc = [...acc, curr.value];
        }

        return newAcc;
      }, []);

      const titles = Array.from(this.wrapper.querySelectorAll('.product__variant-label-box')).reduce(
        (acc, curr) => [...acc, curr.querySelector('span:last-child')],
        []
      );

      titles.forEach((title, index) => {
        title.innerText = this.optionsValues[index];
      });
    }

    if (selector === 'select') {
      this.optionsValues = Array.from(el.querySelectorAll(selector), (item) => item.value);
    }
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find(
      (variant) => !variant.options.map((option, index) => this.optionsValues[index] === option).includes(false)
    );
  }

  updateVariantInput(variant) {
    if (!variant) return false;

    this.inputName.value = variant.id;
    this.inputName.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateVariantUrl(variant) {
    if (!variant) return;
    const url = Shopify.theme.productForm.getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: url }, '', url);
  }

  onOptionChange(variant) {
    // this.updatePickupAvailability(variant);
    this.updateVariantPrice(variant);
    // this.updateVariantUnitPrice(variant);
    this.updateSubmitButton(variant);
    this.updateVariantUrl(variant);
    // this.updateGallery(variant);
  }

  getProduct() {
    let product;
    try {
      product = JSON.parse(this.wrapper.querySelector('#product-json').innerHTML);
    } catch (error) {
      console.warn(error);
    }

    return product;
  }

  updateSubmitButton(variant) {
    if (!variant) {
      this.submitButton.classList.add('disabled');
      this.submitButton.setAttribute('disabled', 'disabled');
      this.submitButtonText.innerText = theme.strings.unavailable;
      this.shopifyButtons?.classList.add('hidden');
      this.availabilityBlock?.classList.add('hidden');
    } else if (variant.available) {
      this.submitButton.classList.remove('disabled');
      this.submitButton.removeAttribute('disabled');
      var price = variant.price;
      var html = `<span>${theme.strings.addToCart}</span>`
      this.submitButtonText.innerHTML = html;
      this.shopifyButtons?.classList.remove('hidden');
      this.availabilityBlock?.classList.remove('hidden');

       var variantStatus = inventories[this.product.id][variant.id];

      if (variantStatus && variantStatus.policy == 'continue' && variantStatus.quantity <= 0 && variant.inventory_management == 'shopify') {
        if (this.availabilityInStock) this.availabilityInStock.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="22px" height="22px" style="fill: #a00;"><path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 z M 32.990234 15.986328 A 1.0001 1.0001 0 0 0 32.292969 16.292969 L 25 23.585938 L 17.707031 16.292969 A 1.0001 1.0001 0 0 0 16.990234 15.990234 A 1.0001 1.0001 0 0 0 16.292969 17.707031 L 23.585938 25 L 16.292969 32.292969 A 1.0001 1.0001 0 1 0 17.707031 33.707031 L 25 26.414062 L 32.292969 33.707031 A 1.0001 1.0001 0 1 0 33.707031 32.292969 L 26.414062 25 L 33.707031 17.707031 A 1.0001 1.0001 0 0 0 32.990234 15.986328 z"/></svg>`+theme.product.pre_order;
      } else {
        if (this.availabilityInStock) this.availabilityInStock.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="22px" height="22px" style="fill: #0a0;"><path d="M 24 3 C 12.413858 3 3 12.413866 3 24 C 3 35.586134 12.413858 45 24 45 C 35.586142 45 45 35.586134 45 24 C 45 12.413866 35.586142 3 24 3 z M 24 5 C 34.505263 5 43 13.494744 43 24 C 43 34.505256 34.505263 43 24 43 C 13.494737 43 5 34.505256 5 24 C 5 13.494744 13.494737 5 24 5 z M 33.003906 15.988281 A 1.0001 1.0001 0 0 0 32.181641 16.425781 L 22.292969 30.552734 L 15.625 25.21875 A 1.0004882 1.0004882 0 1 0 14.375 26.78125 L 21.875 32.78125 A 1.0001 1.0001 0 0 0 23.318359 32.574219 L 33.818359 17.574219 A 1.0001 1.0001 0 0 0 33.003906 15.988281 z"/></svg>`+theme.product.in_stock;
      }
    } else {
      var html = `<span>${theme.strings.soldOut}</span>`
      this.submitButtonText.innerHTML = html;
      this.submitButton.classList.add('disabled');
      this.submitButton.setAttribute('disabled', 'disabled');
      this.shopifyButtons?.classList.add('hidden');
      this.availabilityBlock?.classList.remove('hidden');

      if (this.availabilityInStock) this.availabilityInStock.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="22px" height="22px" style="fill: #a00;"><path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 z M 32.990234 15.986328 A 1.0001 1.0001 0 0 0 32.292969 16.292969 L 25 23.585938 L 17.707031 16.292969 A 1.0001 1.0001 0 0 0 16.990234 15.990234 A 1.0001 1.0001 0 0 0 16.292969 17.707031 L 23.585938 25 L 16.292969 32.292969 A 1.0001 1.0001 0 1 0 17.707031 33.707031 L 25 26.414062 L 32.292969 33.707031 A 1.0001 1.0001 0 1 0 33.707031 32.292969 L 26.414062 25 L 33.707031 17.707031 A 1.0001 1.0001 0 0 0 32.990234 15.986328 z"/></svg>`+theme.product.out_of_stock;
    }
  }

  updateVariantPrice(variant) {
    while (this.priceContainer.firstChild) this.priceContainer.removeChild(this.priceContainer.firstChild);

    if (variant) {
      if (variant.compare_at_price > variant.price) {
        this.priceContainer.innerHTML = `<ins>${formatMoney(variant.price, theme.moneyFormat)}</ins>
          <del>${formatMoney(variant.compare_at_price, theme.moneyFormat)}</del>`;
      } else {
        this.priceContainer.innerHTML = `<div>${formatMoney(variant.price, theme.moneyFormat)}</div>`;
      }
    }
  }

  updateVariantUnitPrice(variant) {
    initUpdateVariantUnitPrice(variant, this.wrapper);
  }

  updateGallery(variant) {
    if (!variant) return false;

    const sliderWrapper = this.wrapper.querySelector('.product__gallery-slider');

    if (!sliderWrapper) return false;

    const currentVariantSliderItem = sliderWrapper.querySelector(
      `.product__gallery-slider__img[data-position="${variant.featured_image?.position}"]`
    );

    currentVariantSliderItem &&
      window.ResponsiveHelper.addRange({
        '..767': {
          on() {
            const imageWidth = currentVariantSliderItem.getBoundingClientRect().width;

            const sliderItemMargin = getComputedStyle(currentVariantSliderItem.parentElement).marginRight.split(
              'px'
            )[0];

            const variantImagePosition = variant.featured_image.position;

            const scrollToIndex = Array.from(sliderWrapper.children).findIndex(
              (elem) => +elem.querySelector('.product__gallery-slider__img').dataset.position === variantImagePosition
            );

            variantImagePosition && sliderWrapper.scrollTo((+sliderItemMargin + imageWidth) * scrollToIndex, 0);
          },
        },
        '768..': {
          on() {
            if (
              sliderWrapper.firstElementChild
                .querySelector('.product__gallery-slider__img')
                .getAttribute('data-position') === currentVariantSliderItem.getAttribute('data-position')
            )
              return false;

            sliderWrapper.prepend(currentVariantSliderItem.parentElement);
          },
        },
      });
  }

  initSubmit() {
    if (!this.variantSelects && !this.variantRadios) {
      this.productForm = this.wrapper.querySelector('#product-id').form;
    }

    this.productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.initAddToBag(e);
    });
  }

  initAddToBag(event) {
    event.preventDefault();

    const serializedForm = serializeArray(event.target);

    const variantId = serializedForm.find((item) => item.name === 'id')?.value;

    const quantity = this.wrapper.querySelector('#Quantity')?.value || 1;

    const sellingPlan = serializedForm.reduce((acc, curr) => {
      let newAcc;

      if (curr.name.includes('selling_plan') || curr.name.includes('selling_plan_radio')) {
        newAcc = { ...acc, [curr.name]: curr.value };
      }

      return newAcc;
    }, {});

    const properties = serializedForm.reduce((acc, curr) => {
      let newAcc;

      if (curr.name.includes('properties')) {
        const prop = curr.name.split('[')[1].split(']')[0];

        newAcc = { ...acc, [prop]: curr.value };
      }

      return newAcc;
    }, {});

    const data = {
      items: [
        {
          quantity,
          id: variantId,
          properties,
          ...sellingPlan,
        },
      ],
    };
    

    addItem(data).then((response) => {
      const { items } = response;

      this.handleErrorMessage(response.description);

      if (!items) return;

      // window.Store.dispatch(addJustAdded(items[0]));
      if (theme.cart.cartDrawer === 'drawer') {
        window.Store.dispatch(getCart());
      } else {
        window.location.href = "/cart";
      }
      
    });
  }

  waitForElement = (selector) =>
    new Promise((resolve) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const nodes = Array.from(mutation.addedNodes);

          for (const node of nodes) {
            const button = node.querySelector(selector);

            if (button && !button.disabled) {
              observer.disconnect();
              resolve(button);

              return;
            }
          }
        });
      });

      if (this.wrapper.querySelectorAll('.shopify-payment-button')[0]) {
        observer.observe(this.wrapper.querySelectorAll('.shopify-payment-button')[0], {
          subtree: true,
          attributes: true,
          childList: true,
        });
      }
    });

  getVariantData(el) {
    if (!el) return;

    this.variantData = this.variantData || JSON.parse(el.querySelector('[type="application/json"]').textContent);
  }

  sizeChartInit() {
    if (!this.sizeChart) return false;

    import('@fancyapps/ui/dist/fancybox.css');
    import('@fancyapps/ui/src/Fancybox/Fancybox.js').then(({ Fancybox }) => {
      Fancybox.bind('.size-chart-link', {
        closeButton: 'outside',
        showClass: 'size-chart',
        dragToClose: false,
        on: {
          reveal: () => {
            const tableWrapper = this.wrapper.querySelector('table');

            tableWrapper.parentElement.classList.add('table-holder');
          },
        },
      });
    });
  }

  initFancybox() {
    if (document.querySelectorAll('[data-fancybox="gallery"]').length > 0) {
      Fancybox.bind('[data-fancybox="gallery"]', {
        mainClass: 'fancybox-product-images',
        buttons: [
          "slideShow",
          "thumbs",
          "zoom",
          "fullScreen",
          "share",
          "close"
        ],
        loop: false,
        protect: true
      });
    }
  }

  initProductRecommendations() {
    const productRecommendationsContainer = this.wrapper.querySelector('#complementary-products-container');

    if (!productRecommendationsContainer) return false;

    fetch(productRecommendationsContainer.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');

        html.innerHTML = text;
        const recommendations = html.querySelector('#complementary-products-container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsContainer.innerHTML = recommendations.innerHTML;
          const accordionContainer = productRecommendationsContainer.querySelector('.js-complementary-accordion');

          this.accordion = new Accordion(accordionContainer, {
            modal: true,
            noAria: true,
            closeClass: 'close',
            enabledClass: 'enabled',
            openClass: 'open',
            heightOffset: 10,
            useBorders: true,
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

register('product', {
  _initProduct(handle) {
    if (handle) window.Product = new Product(this.container);
  },

  productImageSlider() {
   if (this.container.querySelector('.mobile_slider')) { 
    if (this.splide && typeof this.splide.destroy === 'function') {
      this.splide.destroy();
    }
    if (window.innerWidth < 768) {
      this.splide = new Splide(this.container.querySelector('.mobile_slider'), {
        type: 'loop',
        speed: 800,
        perPage: 1,
        gap: 0,
        pagination: false,
        arrows: true,
      }).mount();
    } else {
      if (this.splide && typeof this.splide.destroy === 'function') {
        this.splide.destroy();
      }
    }
    var __this = this;
    window.addEventListener("resize", debounce(() => {
      if (window.innerWidth < 768) {
        if (__this.splide && typeof __this.splide.destroy === 'function') {
          __this.splide.destroy();
        }
        __this.splide = new Splide(__this.container.querySelector('.mobile_slider'), {
          type: 'loop',
          speed: 800,
          perPage: 1,
          gap: 0,
          pagination: false,
          arrows: true,
        }).mount();
      } else {
        if (__this.splide && typeof __this.splide.destroy === 'function') {
          __this.splide.destroy();
        }
      }
    }, 300));
   }
  },

  onLoad() {
    performanceMeasure(this.id, this._initProduct.bind(this, this.container.dataset.handle));
    performanceMeasure(this.id, this.productImageSlider.bind(this));
  },

  onUnload() {
    this.splide.destroy();
  },

  onBlockSelect() {
    this._initProduct(this.container.dataset.handle);
  },
});
load('product');

class RelatedProducts {
  constructor(elem, sectionId) {
    this.wrapper = elem;
    this.limit = this.wrapper.getAttribute('data-limit');

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this.wrapper);
      this.init(sectionId);
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this.wrapper);
  }

  async initRelatedProducts() {
    const url = this.wrapper.getAttribute('data-url');
    const response = await fetch(url);
    const text = await response.text();

    return text;
  }

  async init(sectionId) {
    performanceMeasure(
      sectionId,
      async () => {
        const relatedProductsData = await this.initRelatedProducts();

        const container = new DOMParser()
          .parseFromString(relatedProductsData, 'text/html')
          .querySelector('section.section');

        if (container !== null) {
          this.wrapper.appendChild(container);
        } else {
          this.wrapper.classList.toggle('hidden');
        }
      },
      true
    );
  }
}

register('product-recommendations', {
  onLoad() {
    new RelatedProducts(this.container, this.id);
  },
});

load('product-recommendations');